import React from 'react';
import { Icons, SVG } from '../../../../components/atoms/SVG';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

type AddFormElements = {
  name: string;
  modifier?: Modifier<'no-margin-bottom'>
  onClick: () => void;
};

export function AddFormElements({ name, modifier, onClick }: AddFormElements) {
  return (
    <button type="button" className={bem('add-form-elements', modifier) + ''} onClick={onClick}>
      <span className="add-form-elements__name font-bold-16-21">{name}</span>
      <span className="add-form-elements__icon">
        <SVG svgSpriteId={Icons.ADD_PLUS} />
      </span>
    </button>
  );
}
